import type { CreationArtifactEdgeV1, CreationArtifactUsageV1 } from '@djgg/creations';
import { useSubscription } from '../hooks/useSubscription.js';
import { useServices } from '../services/context.js';

/** Public-safe lineage and binding decisions. Reading them never dispatches work. */
export function useCreationArtifactRelations(runId: string | null): {
  edges: CreationArtifactEdgeV1[];
  usages: CreationArtifactUsageV1[];
} {
  const services = useServices();
  const edges = useSubscription<CreationArtifactEdgeV1[]>(
    cb => runId ? services.subscribe.creationArtifactEdges(runId, cb) : (() => {}),
    [], [runId]);
  const usages = useSubscription<CreationArtifactUsageV1[]>(
    cb => runId ? services.subscribe.creationArtifactUsages(runId, cb) : (() => {}),
    [], [runId]);
  return { edges, usages };
}
